// extracted by mini-css-extract-plugin
export default {"BtnLinkRight":"btn-link_BtnLinkRight__19rLj","BtnLinkLeft":"btn-link_BtnLinkLeft__ur89n","BtnLink__icon":"btn-link_BtnLink__icon__94-ip"};